import { render, staticRenderFns } from "./blob_content.vue?vue&type=template&id=f994d560&"
import script from "./blob_content.vue?vue&type=script&lang=js&"
export * from "./blob_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports